<template>
    <v-ons-page>
        <ons-toolbar>
            <div class="left"><ons-back-button></ons-back-button></div>
            <div class="center">Search {{title}}</div>
        </ons-toolbar>
        <div class="qf-search-filter">
            <div class="center">
                <v-ons-search-input
                    v-model="searchString" model-event="keyup"
                    ></v-ons-search-input>
            </div>
        </div>
        <ons-list>
            <ons-list-item
                v-for="(viableOption,optnIndex) in filteredResults"
                :key="optnIndex"
                @click="pickEntry(viableOption)"
            >{{viableOption.value}} ({{viableOption.count}})</ons-list-item>
        </ons-list>
    </v-ons-page>
</template>

<script>
    //import multimatch from 'multimatch';
    export default {
        name: "SingleFilter",
        data() {
            return {
                filteredResults: {},
                searchString: null,
            };
        },
        mounted() {
            this.filteredResults = this.filter.results;
        },
        methods: {
            searchStringInArray (str) {
                let matchingResults = [];
                if(this.filter.results.length >0){
                    this.filter.results.forEach(function(oneResult){
                        let hasMatch = oneResult.value.toLowerCase().search(str.toLowerCase());
                        if (hasMatch > -1) { // eslint-disable-line
                            matchingResults.push(oneResult);
                        }
                    });
                }
                return matchingResults;
            },
            searchInOptions(searchStr){
                this.filteredResults = this.searchStringInArray(searchStr);
            },
            pickEntry(entry){
                let entryObj = {
                    id: this.filter.id,
                    filterVal: entry.value
                };
                this.$store.commit('collections/addFilterValue', entryObj);
                this.$store.commit('navigator/pop');
            }
        },
        watch: {
            searchString: {
                immediate: true,
                handler(newValue){
                    if(newValue && newValue !== ''){
                        this.searchInOptions(newValue);
                    }else{
                        this.filteredResults = this.filter.results;
                    }
                }
            }

        }
    }
</script>

<style scoped>

</style>
